import { component } from "@uesio/ui";
import login_google from "../src/components/logingoogle/logingoogle";
component.registry.register("uesio/appkit.login_google",login_google);